<template>
  <!--专家指定申报评审页面，显示该申报基本信息，并以子组件DeclareProjMark显示该申报下的所有申报项目，传入参数为指定申报所有信息-->
  <v-container fluid grid-list-sm>

    <v-layout row wrap>
      <v-flex xs12>
        <basic :review="item"/>
      </v-flex>

      <v-flex d-flex xs12 sm12 md12 lg7>
          <v-flex xs12 d-flex>
            <attachment :review="item"/>
          </v-flex>
      </v-flex>

      <v-flex d-flex xs12 sm12 md12 lg5>
          <v-flex xs12 d-flex>
            <review-template :review="item"/>
          </v-flex>
      </v-flex>

      <v-flex xs12>
        <DeclareProjMark
            :reviewId="item"
        />
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import Basic from '@/components/proj/review/Basic'
import Attachment from "@/components/proj/review/Attachment";
import ReviewTemplate from "@/components/proj/review/ReviewTemplate";
import DeclareProjMark from "@/components/proj/review/DeclareProjMark";
const baseUri = '/api/proj/review';
import Vue from "vue";

export default {
  name: "ReviewMark",
  components: {Basic, Attachment, ReviewTemplate, DeclareProjMark},
  props: ("reviewId"),
  data: () => ({
    item: {
      status: {},
    },
  }),

  // 路由进入前，组件就未完成渲染，不可以使用 this
  beforeRouteEnter(to, from, next) {
    window.console.log("In edit_page beforeRouteEnter");
    const dbid = to.params.dbid;
    window.console.log("dbid")
    window.console.log(dbid)
    if (dbid) {
      //获取基本信息
      Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
              rsp => next(vm => {
                vm.dbid = dbid;
                vm.item = rsp.data;
                window.console.log("vm.item")
                window.console.log(vm.item)
                // 保存默认数据
                vm.defaultItem = window.xutil.clone(vm.item);
                vm.loading = false
              })
          )

    } else {
      next();
    }
  },

}
</script>

<style scoped>

</style>